import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// แถบ sub-tab ของแท็บ "วันนี้" ในหน้า /profile/payment-approval และ /profile/expense-review
// (อนุมัติวันนี้ / ด่วน / จ่ายเงินวันนี้) — สไตล์ pill เดียวกับแท็บแม่ + sub-tab ของ /finance/expenses
export default function TodaySubTabBar({ subTabs, value, onChange, counts = {} }) {
  return (
    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 0.75,
          p: 0.75,
          borderRadius: '18px',
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          boxShadow: (theme) =>
            theme.palette.mode === 'dark'
              ? '0 4px 20px rgba(0,0,0,0.35)'
              : '0 4px 20px rgba(15,23,42,0.06)',
        }}
      >
        {subTabs.map((t) => {
          const selected = value === t.key;
          const Icon = t.icon;
          return (
            <Box
              key={t.key}
              onClick={() => onChange(t.key)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.9,
                px: 2,
                py: 1,
                borderRadius: '14px',
                cursor: 'pointer',
                userSelect: 'none',
                whiteSpace: 'nowrap',
                transition:
                  'transform 0.2s ease, background-color 0.2s ease, box-shadow 0.25s ease',
                transform: selected ? 'translateY(-1px)' : 'none',
                background: selected ? t.gradient : 'transparent',
                boxShadow: selected ? '0 6px 16px -4px rgba(0,0,0,0.35)' : 'none',
                '&:hover': {
                  background: selected
                    ? t.gradient
                    : (theme) =>
                        (theme.palette.mode === 'dark'
                          ? 'rgba(255,255,255,0.06)'
                          : 'rgba(15,23,42,0.04)'),
                },
              }}
            >
              <Icon
                sx={{ fontSize: 19, color: selected ? '#fff' : 'text.secondary' }}
              />
              <Typography
                sx={{
                  fontSize: '0.85rem',
                  fontWeight: selected ? 700 : 500,
                  color: selected ? '#fff' : 'text.secondary',
                }}
              >
                {t.label}
              </Typography>
              {typeof counts[t.key] === 'number' && (
                <Box
                  sx={{
                    minWidth: 20,
                    height: 20,
                    px: 0.7,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '999px',
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    lineHeight: 1,
                    bgcolor: selected
                      ? 'rgba(255,255,255,0.28)'
                      : (theme) =>
                          (theme.palette.mode === 'dark'
                            ? 'rgba(255,255,255,0.12)'
                            : 'rgba(15,23,42,0.07)'),
                    color: selected ? '#fff' : 'text.secondary',
                  }}
                >
                  {counts[t.key]}
                </Box>
              )}
            </Box>
          );
        })}
      </Paper>
    </Box>
  );
}
